export const regexEmail = /\S+@\S+\.\S+/;
export const regexPhoneNumberVariant = /^[0-9\-\+\(\)\ ]+$/;
export const regexZip = /^[0-9\ \-]+$/;
export const regexPersonalNumber = /^(19|20)(\d{6}(-|\s)\d{4}|(?!19|20)\d{10})$/;
export const regexRegistrationNumberSweden = /[a-zA-Z]{3}\d{2}(d||[a-zA-Z]){1}/;
export const regexRegistrationNumberNorway = /^[A-Z]{2}\d{5}$/;
export const regexNumber = /\D/g;
